module.exports = __webpack_public_path__ + "static/media/dentalblur.5e46c66b.png";